import React from 'react'
import { useTheme } from '../../mui/Styles/index'

function Ellipse() {
  const theme = useTheme()

  const ellipseStyle = {
    width: '5px',
    height: '5px',
    margin: '0px 8px 1px 0',
    backgroundColor: theme.palette.common.black,
    borderRadius: '6px',
    display: 'inline-flex',
  }

  return <span style={ellipseStyle} />
}

export default Ellipse
